<template>
  <v-app id="app">
    <v-dialog v-if="showSplashAnimation" v-model="showSplashAnimation" fullscreen hide-overlay
      transition="dialog-bottom-transition">
      <v-card class="primary darken-2" style="height: 100%">
        <loading-animation @loopComplete="loopComplete"></loading-animation>
      </v-card>
    </v-dialog>
    <div v-if="currentRouteRequiresAuth && loggedIn">
      <drawer-navigation :menu="authorizedModules" :permanent="permanent" :clipped="clipped"></drawer-navigation>

      <v-app-bar class="px-1 px-sm-4 px-md-5 primary darken-1 elevation-0" height="94.11" :clipped-left="clipped" fixed
        app style="z-index: 7">
        <div to="/Home" tag="span" style="cursor: pointer">
          <v-img :src="require('@/assets/infohidronamebranco.svg')" contain alt="logo"
            :height="$vuetify.breakpoint.name === 'xs' ? '30' : '46'"
            :width="$vuetify.breakpoint.name === 'xs' ? '100' : '188'"></v-img>
        </div>
        <v-spacer></v-spacer>
        <items-menu></items-menu>
      </v-app-bar>

      <v-bottom-navigation v-if="$route.name !== 'Home'" id="mobile-bottom-navigation"
        class="d-flex d-md-none primary darken-1 secondary--text text--lighten-1" height="70"
        :value="BottomNavigationValue" fixed app>
        <div style="display: flex; overflow-x: scroll">
          <v-btn min-width="100" v-for="(item, index) in authorizedModules" :key="index" :to="item.to">
            <span class="mt-2 align-self-start">{{ item.title }}</span>

            <v-icon class="align-self-start">{{ item.icon }}</v-icon>
          </v-btn>
        </div>
      </v-bottom-navigation>
    </div>

    <v-main class="primary darken-2">
      <transition name="slide-fade" mode="out-in" appear>
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
import DrawerNavigation from './components/navigation/DrawerNavigation.vue';
import ItemsMenu from './components/toolbar/ItemsMenu.vue';
import LoadingAnimation from './components/common/LoadingAnimation';
import routes from './router/routes';

export default {
  name: 'App',
  components: {
    ItemsMenu,
    DrawerNavigation,
    LoadingAnimation,
  },
  data: () => ({
    clipped: true,
    drawer: false,
    showSplashAnimation: false,
    menu: [
      {
        icon: 'icon-infohidro-abastecimento',
        title: routes.reservoirs.title,
        to: routes.reservoirs.path,
        authorize: routes.reservoirs.authorize,
      },
      {
        icon: 'mdi-shield-outline',
        title: routes.monitoring.title,
        to: routes.monitoring.path,
        authorize: routes.monitoring.authorize,
      },
      {
        icon: 'mdi-barley',
        title: routes.conservation.title,
        to: routes.conservation.path,
        authorize: routes.conservation.authorize,
      },
      {
        icon: '$Indicator',
        title: routes.indicators.title,
        to: routes.indicators.path,
        authorize: routes.indicators.authorize,
      },
      {
        icon: 'mdi-water-remove-outline',
        title: routes.effluents.title,
        to: routes.effluents.path,
        authorize: routes.effluents.authorize,
      },
      {
        icon: 'mdi-file-document-outline',
        title: routes.stationsData.title,
        to: routes.stationsData.path,
        authorize: routes.stationsData.authorize,
      },
      {
        icon: 'mdi-waves',
        title: routes.undergroundWaters.title,
        to: routes.undergroundWaters.path,
        authorize: routes.undergroundWaters.authorize,
      },
    ],
    miniVariant: true,
    title: 'info hidro',
  }),
  updated() {
    if (this.currentRouteRequiresAuth && this.loggedIn && !this.currentUser) {
      this.showSplashAnimation = true;
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
    currentUser() {
      return this.$store.getters.currentUser;
    },
    currentRouteRequiresAuth() {
      return this.$route.meta.requiresAuth;
    },
    currentUserRoles() {
      const currentUser = this.$store.getters.currentUser;
      if (!currentUser) return [];
      const { roles } = currentUser.attributes;

      if (roles) {
        const listRoles = Array.isArray(roles) ? roles : [roles];

        return listRoles;
      }
      return [];
    },
    authorizedModules() {
      return this.menu.filter((menuItem) =>
        this.currentUserRoles.some((r) => menuItem.authorize.includes(r)),
      );
    },
    permanent() {
      return (
        this.$vuetify.breakpoint.name !== 'xs' &&
        this.$vuetify.breakpoint.name !== 'sm'
      );
    },
    BottomNavigationValue() {
      return this.authorizedModules.findIndex(
        (item) => item.to === this.$route.path,
      );
    },
  },
  methods: {
    loopComplete() {
      if (this.currentUser) {
        this.showSplashAnimation = false;
      }
    },
    goHome() {
      return routes.home.path;
    },
  },
};
</script>
<style>
* {
  font-family: Roboto;
}

#app {
  overflow-y: hidden;
}

.slide-fade-enter {
  transform: translateY(-10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.button-text {
  text-transform: none;
}

.theme--dark.v-list {
  background-color: var(--v-primary-darken1);
}

::-webkit-scrollbar {
  width: 15px;
  height: 15px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #6071db;
}

::-webkit-scrollbar-thumb:hover {
  background: #95a1ec;
}

.theme--dark.v-picker__body {
  background-color: var(--v-primary-darken1) !important;
}

.v-picker__actions {
  background-color: var(--v-primary-darken1) !important;
}

input[type='datetime-local']::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

#mobile-bottom-navigation ::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

#mobile-bottom-navigation ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

#mobile-bottom-navigation ::-webkit-scrollbar-thumb {
  background: darkgrey;
}

#mobile-bottom-navigation ::-webkit-scrollbar-thumb:hover {
  background: grey;
}

.v-icon.notranslate.mdi.mdi-chevron-right.theme--dark {
  color: #95a1ec;
}
</style>
